import { render, staticRenderFns } from "./UpdateDrugBatch.vue?vue&type=template&id=3ca31086&scoped=true&lang=pug&"
import script from "./UpdateDrugBatch.vue?vue&type=script&lang=ts&"
export * from "./UpdateDrugBatch.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateDrugBatch.vue?vue&type=style&index=0&id=3ca31086&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca31086",
  null
  
)

export default component.exports